export const EquipmentStatus = Object.freeze({
    Active: "active",
    InActive: "inactive",
    Offline: "offline",
    Online: "online",
    Maintenance: "maintenance",
    Repair: "repair",
    Retired: "retired",
})

export const EquipmentType = Object.freeze({
    Equipment: "equipment",
    Asset: "asset",
    Consumable: "consumable",
})

export const RateBy = Object.freeze({
    Hourly: "hourly",
    Daily: "daily",
    Weekly: "weekly",
    Monthly: "monthly",
})

export const ProjectStatus = Object.freeze({
    TODO: "todo",
    INPROGRESS: "processing",
    COMPLETE: "complete",
})

export const UserRole = Object.freeze({
    Admin: "admin",
    User: "web_user",
    Employee: "employee",
    AccountManager: "account_manager"
})

export const WorklogStatus = Object.freeze({
    Pending: "pending",
    Rejected: "rejected",
    Verified: "verified",
})


export const TicketArray = [
    { label: "LE - Excavator", value: "le_excavator" },
    { label: "LS - Skidsteer", value: "ls_skidsteer" },
    { label: "LB - Backhoe", value: "lb_backhoe" },
    { label: "LG - Grader", value: "lg_grader" },
    { label: "LZ - Dozer", value: "lz_dozer" },
    { label: "WLL - Wheeled Loader", value: "wll_wheeled_loader" },
    { label: "TLL - Tracked Loader", value: "tll_tracked_loader" },
    { label: "LR - Roller", value: "lr_roller" },
    { label: "LC - Compactor", value: "lc_compactor" },
    { label: "FTD - Front Tipping Dumper", value: "ftd_front_tipping_dumper" },
    { label: "AH - Artic Dumper", value: "ah_artic_dumper" },
    { label: "LP - Scraper", value: "lp_scraper" },
    { label: "CCP - Conduct Cast in-situ piling", value: "ccp_conduct_cast_in_situ_piling" },
    { label: "PD - Pile Driving Operations", value: "pd_pile_driving_operations" },
    { label: "WC - Water Cart", value: "wc_water_cart" },
    { label: "TH - Telehandler", value: "th_telehandler" },
    { label: "LF - Forklift", value: "lf_forklift" },
    { label: "RI - Rigging Intermediate", value: "ri_rigging_intermediate" },
    { label: "RA - Rigging Advanced", value: "ra_rigging_advanced" },
    { label: "DG - Dogman", value: "dg_dogman" },
    { label: "WP - Boomlift Over 11mtr", value: "wp_boomlift_over_11mtr" },
    { label: "BL - Boomlift Under 11mtr", value: "bl_boomlift_under_11mtr" },
    { label: "SL - Scissor Lift", value: "sl_scissor_lift" },
    { label: "C0 - Slewing Mobile crane over 100t", value: "c0_slewing_mobile_crane_over_100t" },
    { label: "C1 - Slewing Mobile crane upto 100t", value: "c1_slewing_mobile_crane_upto_100t" },
    { label: "C2 - Slewing Mobile crane upto 20t", value: "c2_slewing_mobile_crane_upto_20t" },
    { label: "C6 - Slewing Mobile crane upto 60t", value: "c6_slewing_mobile_crane_upto_60t" },
    { label: "CN - Crane Non Slewing", value: "cn_crane_non_slewing" },
    { label: "CV - Hiab Crane Truck", value: "cv_hiab_crane_truck" },
    { label: "VE - Vacuum Excavations", value: "ve_vacuum_excavations" },
    { label: "VLC - Vehicle Loading Crane", value: "vlc_vehicle_loading_crane" },
    { label: "CUC - Cut Concrete Quick Cut Saw", value: "cuc_cut_concrete_quick_cut_saw" },
    { label: "SDD - Surface Directional Drill", value: "sdd_surface_directional_drill" },
    { label: "SI - Scaffolding Intermediate", value: "si_scaffolding_intermediate" },
    { label: "SA - Scaffolding Advanced", value: "sa_scaffolding_advanced" },
    { label: "RH - Rigid Haul Truck", value: "rh_rigid_haul_truck" },
    { label: "CSL - Container Side Loader", value: "csl_container_side_loader" },
    { label: "CT - Tower Crane", value: "ct_tower_crane" }
];

export const LicenceArray = [
    {
        label: "C - Car",
        value: "c_car",
    },
    {
        label: "LR - Light Rigid",
        value: "lr_light_rigid"
    },
    {
        label: "HR - Heavy Rigid",
        value: "hr_heavy_rigid"
    },
    {
        label: "MC - Multi Combo",
        value: "mc_multi_combo"
    }
]

export const Countries = [
    { value: 'AF', label: 'Afghanistan' },
    { value: 'AX', label: 'Åland Islands' },
    { value: 'AL', label: 'Albania' },
    { value: 'DZ', label: 'Algeria' },
    { value: 'AS', label: 'American Samoa' },
    { value: 'AD', label: 'Andorra' },
    { value: 'AO', label: 'Angola' },
    { value: 'AI', label: 'Anguilla' },
    { value: 'AQ', label: 'Antarctica' },
    { value: 'AG', label: 'Antigua and Barbuda' },
    { value: 'AR', label: 'Argentina' },
    { value: 'AM', label: 'Armenia' },
    { value: 'AW', label: 'Aruba' },
    { value: 'AU', label: 'Australia' },
    { value: 'AT', label: 'Austria' },
    { value: 'AZ', label: 'Azerbaijan' },
    { value: 'BS', label: 'Bahamas' },
    { value: 'BH', label: 'Bahrain' },
    { value: 'BD', label: 'Bangladesh' },
    { value: 'BB', label: 'Barbados' },
    { value: 'BY', label: 'Belarus' },
    { value: 'BE', label: 'Belgium' },
    { value: 'BZ', label: 'Belize' },
    { value: 'BJ', label: 'Benin' },
    { value: 'BM', label: 'Bermuda' },
    { value: 'BT', label: 'Bhutan' },
    { value: 'BO', label: 'Bolivia, Plurinational State of' },
    { value: 'BQ', label: 'Bonaire, Sint Eustatius and Saba' },
    { value: 'BA', label: 'Bosnia and Herzegovina' },
    { value: 'BW', label: 'Botswana' },
    { value: 'BV', label: 'Bouvet Island' },
    { value: 'BR', label: 'Brazil' },
    { value: 'IO', label: 'British Indian Ocean Territory' },
    { value: 'BN', label: 'Brunei Darussalam' },
    { value: 'BG', label: 'Bulgaria' },
    { value: 'BF', label: 'Burkina Faso' },
    { value: 'BI', label: 'Burundi' },
    { value: 'KH', label: 'Cambodia' },
    { value: 'CM', label: 'Cameroon' },
    { value: 'CA', label: 'Canada' },
    { value: 'CV', label: 'Cape Verde' },
    { value: 'KY', label: 'Cayman Islands' },
    { value: 'CF', label: 'Central African Republic' },
    { value: 'TD', label: 'Chad' },
    { value: 'CL', label: 'Chile' },
    { value: 'CN', label: 'China' },
    { value: 'CX', label: 'Christmas Island' },
    { value: 'CC', label: 'Cocos (Keeling) Islands' },
    { value: 'CO', label: 'Colombia' },
    { value: 'KM', label: 'Comoros' },
    { value: 'CG', label: 'Congo' },
    { value: 'CD', label: 'Congo, the Democratic Republic of the' },
    { value: 'CK', label: 'Cook Islands' },
    { value: 'CR', label: 'Costa Rica' },
    { value: 'CI', label: 'Côte d\'Ivoire' },
    { value: 'HR', label: 'Croatia' },
    { value: 'CU', label: 'Cuba' },
    { value: 'CW', label: 'Curaçao' },
    { value: 'CY', label: 'Cyprus' },
    { value: 'CZ', label: 'Czech Republic' },
    { value: 'DK', label: 'Denmark' },
    { value: 'DJ', label: 'Djibouti' },
    { value: 'DM', label: 'Dominica' },
    { value: 'DO', label: 'Dominican Republic' },
    { value: 'EC', label: 'Ecuador' },
    { value: 'EG', label: 'Egypt' },
    { value: 'SV', label: 'El Salvador' },
    { value: 'GQ', label: 'Equatorial Guinea' },
    { value: 'ER', label: 'Eritrea' },
    { value: 'EE', label: 'Estonia' },
    { value: 'ET', label: 'Ethiopia' },
    { value: 'FK', label: 'Falkland Islands (Malvinas)' },
    { value: 'FO', label: 'Faroe Islands' },
    { value: 'FJ', label: 'Fiji' },
    { value: 'FI', label: 'Finland' },
    { value: 'FR', label: 'France' },
    { value: 'GF', label: 'French Guiana' },
    { value: 'PF', label: 'French Polynesia' },
    { value: 'TF', label: 'French Southern Territories' },
    { value: 'GA', label: 'Gabon' },
    { value: 'GM', label: 'Gambia' },
    { value: 'GE', label: 'Georgia' },
    { value: 'DE', label: 'Germany' },
    { value: 'GH', label: 'Ghana' },
    { value: 'GI', label: 'Gibraltar' },
    { value: 'GR', label: 'Greece' },
    { value: 'GL', label: 'Greenland' },
    { value: 'GD', label: 'Grenada' },
    { value: 'GP', label: 'Guadeloupe' },
    { value: 'GU', label: 'Guam' },
    { value: 'GT', label: 'Guatemala' },
    { value: 'GG', label: 'Guernsey' },
    { value: 'GN', label: 'Guinea' },
    { value: 'GW', label: 'Guinea-Bissau' },
    { value: 'GY', label: 'Guyana' },
    { value: 'HT', label: 'Haiti' },
    { value: 'HM', label: 'Heard Island and McDonald Mcdonald Islands' },
    { value: 'VA', label: 'Holy See (Vatican City State)' },
    { value: 'HN', label: 'Honduras' },
    { value: 'HK', label: 'Hong Kong' },
    { value: 'HU', label: 'Hungary' },
    { value: 'IS', label: 'Iceland' },
    { value: 'IN', label: 'India' },
    { value: 'ID', label: 'Indonesia' },
    { value: 'IR', label: 'Iran, Islamic Republic of' },
    { value: 'IQ', label: 'Iraq' },
    { value: 'IE', label: 'Ireland' },
    { value: 'IM', label: 'Isle of Man' },
    { value: 'IL', label: 'Israel' },
    { value: 'IT', label: 'Italy' },
    { value: 'JM', label: 'Jamaica' },
    { value: 'JP', label: 'Japan' },
    { value: 'JE', label: 'Jersey' },
    { value: 'JO', label: 'Jordan' },
    { value: 'KZ', label: 'Kazakhstan' },
    { value: 'KE', label: 'Kenya' },
    { value: 'KI', label: 'Kiribati' },
    { value: 'KP', label: 'Korea, Democratic People\'s Republic of' },
    { value: 'KR', label: 'Korea, Republic of' },
    { value: 'KW', label: 'Kuwait' },
    { value: 'KG', label: 'Kyrgyzstan' },
    { value: 'LA', label: 'Lao People\'s Democratic Republic' },
    { value: 'LV', label: 'Latvia' },
    { value: 'LB', label: 'Lebanon' },
    { value: 'LS', label: 'Lesotho' },
    { value: 'LR', label: 'Liberia' },
    { value: 'LY', label: 'Libya' },
    { value: 'LI', label: 'Liechtenstein' },
    { value: 'LT', label: 'Lithuania' },
    { value: 'LU', label: 'Luxembourg' },
    { value: 'MO', label: 'Macao' },
    { value: 'MK', label: 'Macedonia, the Former Yugoslav Republic of' },
    { value: 'MG', label: 'Madagascar' },
    { value: 'MW', label: 'Malawi' },
    { value: 'MY', label: 'Malaysia' },
    { value: 'MV', label: 'Maldives' },
    { value: 'ML', label: 'Mali' },
    { value: 'MT', label: 'Malta' },
    { value: 'MH', label: 'Marshall Islands' },
    { value: 'MQ', label: 'Martinique' },
    { value: 'MR', label: 'Mauritania' },
    { value: 'MU', label: 'Mauritius' },
    { value: 'YT', label: 'Mayotte' },
    { value: 'MX', label: 'Mexico' },
    { value: 'FM', label: 'Micronesia, Federated States of' },
    { value: 'MD', label: 'Moldova, Republic of' },
    { value: 'MC', label: 'Monaco' },
    { value: 'MN', label: 'Mongolia' },
    { value: 'ME', label: 'Montenegro' },
    { value: 'MS', label: 'Montserrat' },
    { value: 'MA', label: 'Morocco' },
    { value: 'MZ', label: 'Mozambique' },
    { value: 'MM', label: 'Myanmar' },
    { value: 'NA', label: 'Namibia' },
    { value: 'NR', label: 'Nauru' },
    { value: 'NP', label: 'Nepal' },
    { value: 'NL', label: 'Netherlands' },
    { value: 'NC', label: 'New Caledonia' },
    { value: 'NZ', label: 'New Zealand' },
    { value: 'NI', label: 'Nicaragua' },
    { value: 'NE', label: 'Niger' },
    { value: 'NG', label: 'Nigeria' },
    { value: 'NU', label: 'Niue' },
    { value: 'NF', label: 'Norfolk Island' },
    { value: 'MP', label: 'Northern Mariana Islands' },
    { value: 'NO', label: 'Norway' },
    { value: 'OM', label: 'Oman' },
    { value: 'PK', label: 'Pakistan' },
    { value: 'PW', label: 'Palau' },
    { value: 'PS', label: 'Palestine, State of' },
    { value: 'PA', label: 'Panama' },
    { value: 'PG', label: 'Papua New Guinea' },
    { value: 'PY', label: 'Paraguay' },
    { value: 'PE', label: 'Peru' },
    { value: 'PH', label: 'Philippines' },
    { value: 'PN', label: 'Pitcairn' },
    { value: 'PL', label: 'Poland' },
    { value: 'PT', label: 'Portugal' },
    { value: 'PR', label: 'Puerto Rico' },
    { value: 'QA', label: 'Qatar' },
    { value: 'RE', label: 'Réunion' },
    { value: 'RO', label: 'Romania' },
    { value: 'RU', label: 'Russian Federation' },
    { value: 'RW', label: 'Rwanda' },
    { value: 'BL', label: 'Saint Barthélemy' },
    { value: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha' },
    { value: 'KN', label: 'Saint Kitts and Nevis' },
    { value: 'LC', label: 'Saint Lucia' },
    { value: 'MF', label: 'Saint Martin (French part)' },
    { value: 'PM', label: 'Saint Pierre and Miquelon' },
    { value: 'VC', label: 'Saint Vincent and the Grenadines' },
    { value: 'WS', label: 'Samoa' },
    { value: 'SM', label: 'San Marino' },
    { value: 'ST', label: 'Sao Tome and Principe' },
    { value: 'SA', label: 'Saudi Arabia' },
    { value: 'SN', label: 'Senegal' },
    { value: 'RS', label: 'Serbia' },
    { value: 'SC', label: 'Seychelles' },
    { value: 'SL', label: 'Sierra Leone' },
    { value: 'SG', label: 'Singapore' },
    { value: 'SX', label: 'Sint Maarten (Dutch part)' },
    { value: 'SK', label: 'Slovakia' },
    { value: 'SI', label: 'Slovenia' },
    { value: 'SB', label: 'Solomon Islands' },
    { value: 'SO', label: 'Somalia' },
    { value: 'ZA', label: 'South Africa' },
    { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
    { value: 'SS', label: 'South Sudan' },
    { value: 'ES', label: 'Spain' },
    { value: 'LK', label: 'Sri Lanka' },
    { value: 'SD', label: 'Sudan' },
    { value: 'SR', label: 'Suriname' },
    { value: 'SJ', label: 'Svalbard and Jan Mayen' },
    { value: 'SZ', label: 'Swaziland' },
    { value: 'SE', label: 'Sweden' },
    { value: 'CH', label: 'Switzerland' },
    { value: 'SY', label: 'Syrian Arab Republic' },
    { value: 'TW', label: 'Taiwan, Province of China' },
    { value: 'TJ', label: 'Tajikistan' },
    { value: 'TZ', label: 'Tanzania, United Republic of' },
    { value: 'TH', label: 'Thailand' },
    { value: 'TL', label: 'Timor-Leste' },
    { value: 'TG', label: 'Togo' },
    { value: 'TK', label: 'Tokelau' },
    { value: 'TO', label: 'Tonga' },
    { value: 'TT', label: 'Trinidad and Tobago' },
    { value: 'TN', label: 'Tunisia' },
    { value: 'TR', label: 'Turkey' },
    { value: 'TM', label: 'Turkmenistan' },
    { value: 'TC', label: 'Turks and Caicos Islands' },
    { value: 'TV', label: 'Tuvalu' },
    { value: 'UG', label: 'Uganda' },
    { value: 'UA', label: 'Ukraine' },
    { value: 'AE', label: 'United Arab Emirates' },
    { value: 'GB', label: 'United Kingdom' },
    { value: 'US', label: 'United States' },
    { value: 'UM', label: 'United States Minor Outlying Islands' },
    { value: 'UY', label: 'Uruguay' },
    { value: 'UZ', label: 'Uzbekistan' },
    { value: 'VU', label: 'Vanuatu' },
    { value: 'VE', label: 'Venezuela, Bolivarian Republic of' },
    { value: 'VN', label: 'Viet Nam' },
    { value: 'VG', label: 'Virgin Islands, British' },
    { value: 'VI', label: 'Virgin Islands, U.S.' },
    { value: 'WF', label: 'Wallis and Futuna' },
    { value: 'EH', label: 'Western Sahara' },
    { value: 'YE', label: 'Yemen' },
    { value: 'ZM', label: 'Zambia' },
    { value: 'ZW', label: 'Zimbabwe' },
]

export const Timezones = [
    {
        "zone": "Pacific/Midway",
        "gmt": "(GMT-11:00)",
        "name": "Midway Island"
    },
    {
        "zone": "US/Samoa",
        "gmt": "(GMT-11:00)",
        "name": "Samoa"
    },
    {
        "zone": "US/Hawaii",
        "gmt": "(GMT-10:00)",
        "name": "Hawaii"
    },
    {
        "zone": "US/Alaska",
        "gmt": "(GMT-09:00)",
        "name": "Alaska"
    },
    {
        "zone": "US/Pacific",
        "gmt": "(GMT-08:00)",
        "name": "Pacific Time (US &amp; Canada)"
    },
    {
        "zone": "America/Tijuana",
        "gmt": "(GMT-08:00)",
        "name": "Tijuana"
    },
    {
        "zone": "US/Arizona",
        "gmt": "(GMT-07:00)",
        "name": "Arizona"
    },
    {
        "zone": "US/Mountain",
        "gmt": "(GMT-07:00)",
        "name": "Mountain Time (US &amp; Canada)"
    },
    {
        "zone": "America/Chihuahua",
        "gmt": "(GMT-07:00)",
        "name": "Chihuahua"
    },
    {
        "zone": "America/Mazatlan",
        "gmt": "(GMT-07:00)",
        "name": "Mazatlan"
    },
    {
        "zone": "America/Mexico_City",
        "gmt": "(GMT-06:00)",
        "name": "Mexico City"
    },
    {
        "zone": "America/Monterrey",
        "gmt": "(GMT-06:00)",
        "name": "Monterrey"
    },
    {
        "zone": "Canada/Saskatchewan",
        "gmt": "(GMT-06:00)",
        "name": "Saskatchewan"
    },
    {
        "zone": "US/Central",
        "gmt": "(GMT-06:00)",
        "name": "Central Time (US &amp; Canada)"
    },
    {
        "zone": "US/Eastern",
        "gmt": "(GMT-05:00)",
        "name": "Eastern Time (US &amp; Canada)"
    },
    {
        "zone": "US/East-Indiana",
        "gmt": "(GMT-05:00)",
        "name": "Indiana (East)"
    },
    {
        "zone": "America/Bogota",
        "gmt": "(GMT-05:00)",
        "name": "Bogota"
    },
    {
        "zone": "America/Lima",
        "gmt": "(GMT-05:00)",
        "name": "Lima"
    },
    {
        "zone": "America/Caracas",
        "gmt": "(GMT-04:30)",
        "name": "Caracas"
    },
    {
        "zone": "Canada/Atlantic",
        "gmt": "(GMT-04:00)",
        "name": "Atlantic Time (Canada)"
    },
    {
        "zone": "America/La_Paz",
        "gmt": "(GMT-04:00)",
        "name": "La_Paz"
    },
    {
        "zone": "America/Santiago",
        "gmt": "(GMT-04:00)",
        "name": "Santiago"
    },
    {
        "zone": "Canada/Newfoundland",
        "gmt": "(GMT-03:30)",
        "name": "Newfoundland"
    },
    {
        "zone": "America/Buenos_Aires",
        "gmt": "(GMT-03:00)",
        "name": "Buenos Aires"
    },
    {
        "zone": "Greenland",
        "gmt": "(GMT-03:00)",
        "name": "Greenland"
    },
    {
        "zone": "Atlantic/Stanley",
        "gmt": "(GMT-02:00)",
        "name": "Stanley"
    },
    {
        "zone": "Atlantic/Azores",
        "gmt": "(GMT-01:00)",
        "name": "Azores"
    },
    {
        "zone": "Atlantic/Cape_Verde",
        "gmt": "(GMT-01:00)",
        "name": "Cape Verde Is."
    },
    {
        "zone": "Africa/Casablanca",
        "gmt": "(GMT)",
        "name": "Casablanca"
    },
    {
        "zone": "Europe/Dublin",
        "gmt": "(GMT)",
        "name": "Dublin"
    },
    {
        "zone": "Europe/Lisbon",
        "gmt": "(GMT)",
        "name": "Libson"
    },
    {
        "zone": "Europe/London",
        "gmt": "(GMT)",
        "name": "London"
    },
    {
        "zone": "Africa/Monrovia",
        "gmt": "(GMT)",
        "name": "Monrovia"
    },
    {
        "zone": "Europe/Amsterdam",
        "gmt": "(GMT+01:00)",
        "name": "Amsterdam"
    },
    {
        "zone": "Europe/Belgrade",
        "gmt": "(GMT+01:00)",
        "name": "Belgrade"
    },
    {
        "zone": "Europe/Berlin",
        "gmt": "(GMT+01:00)",
        "name": "Berlin"
    },
    {
        "zone": "Europe/Bratislava",
        "gmt": "(GMT+01:00)",
        "name": "Bratislava"
    },
    {
        "zone": "Europe/Brussels",
        "gmt": "(GMT+01:00)",
        "name": "Brussels"
    },
    {
        "zone": "Europe/Budapest",
        "gmt": "(GMT+01:00)",
        "name": "Budapest"
    },
    {
        "zone": "Europe/Copenhagen",
        "gmt": "(GMT+01:00)",
        "name": "Copenhagen"
    },
    {
        "zone": "Europe/Ljubljana",
        "gmt": "(GMT+01:00)",
        "name": "Ljubljana"
    },
    {
        "zone": "Europe/Madrid",
        "gmt": "(GMT+01:00)",
        "name": "Madrid"
    },
    {
        "zone": "Europe/Paris",
        "gmt": "(GMT+01:00)",
        "name": "Paris"
    },
    {
        "zone": "Europe/Prague",
        "gmt": "(GMT+01:00)",
        "name": "Prague"
    },
    {
        "zone": "Europe/Rome",
        "gmt": "(GMT+01:00)",
        "name": "Rome"
    },
    {
        "zone": "Europe/Sarajevo",
        "gmt": "(GMT+01:00)",
        "name": "Sarajevo"
    },
    {
        "zone": "Europe/Skopje",
        "gmt": "(GMT+01:00)",
        "name": "Skopje"
    },
    {
        "zone": "Europe/Stockholm",
        "gmt": "(GMT+01:00)",
        "name": "Stockholm"
    },
    {
        "zone": "Europe/Vienna",
        "gmt": "(GMT+01:00)",
        "name": "Vienna"
    },
    {
        "zone": "Europe/Warsaw",
        "gmt": "(GMT+01:00)",
        "name": "Warsaw"
    },
    {
        "zone": "Europe/Zagreb",
        "gmt": "(GMT+01:00)",
        "name": "Zagreb"
    },
    {
        "zone": "Europe/Athens",
        "gmt": "(GMT+02:00)",
        "name": "Athens"
    },
    {
        "zone": "Europe/Bucharest",
        "gmt": "(GMT+02:00)",
        "name": "Bucharest"
    },
    {
        "zone": "Africa/Cairo",
        "gmt": "(GMT+02:00)",
        "name": "Cairo"
    },
    {
        "zone": "Africa/Harare",
        "gmt": "(GMT+02:00)",
        "name": "Harere"
    },
    {
        "zone": "Europe/Helsinki",
        "gmt": "(GMT+02:00)",
        "name": "Helsinki"
    },
    {
        "zone": "Europe/Istanbul",
        "gmt": "(GMT+02:00)",
        "name": "Istanbul"
    },
    {
        "zone": "Asia/Jerusalem",
        "gmt": "(GMT+02:00)",
        "name": "Jerusalem"
    },
    {
        "zone": "Europe/Kiev",
        "gmt": "(GMT+02:00)",
        "name": "Kiev"
    },
    {
        "zone": "Europe/Minsk",
        "gmt": "(GMT+02:00)",
        "name": "Minsk"
    },
    {
        "zone": "Europe/Riga",
        "gmt": "(GMT+02:00)",
        "name": "Riga"
    },
    {
        "zone": "Europe/Sofia",
        "gmt": "(GMT+02:00)",
        "name": "Sofia"
    },
    {
        "zone": "Europe/Tallinn",
        "gmt": "(GMT+02:00)",
        "name": "Tallinn"
    },
    {
        "zone": "Europe/Vilnius",
        "gmt": "(GMT+02:00)",
        "name": "Vilnius"
    },
    {
        "zone": "Asia/Baghdad",
        "gmt": "(GMT+03:00)",
        "name": "Baghdad"
    },
    {
        "zone": "Asia/Kuwait",
        "gmt": "(GMT+03:00)",
        "name": "Kuwait"
    },
    {
        "zone": "Africa/Nairobi",
        "gmt": "(GMT+03:00)",
        "name": "Nairobi"
    },
    {
        "zone": "Asia/Riyadh",
        "gmt": "(GMT+03:00)",
        "name": "Riyadh"
    },
    {
        "zone": "Asia/Tehran",
        "gmt": "(GMT+03:30)",
        "name": "Tehran"
    },
    {
        "zone": "Europe/Moscow",
        "gmt": "(GMT+04:00)",
        "name": "Moscow"
    },
    {
        "zone": "Asia/Baku",
        "gmt": "(GMT+04:00)",
        "name": "Baku"
    },
    {
        "zone": "Europe/Volgograd",
        "gmt": "(GMT+04:00)",
        "name": "Volgograd"
    },
    {
        "zone": "Asia/Muscat",
        "gmt": "(GMT+04:00)",
        "name": "Muscat"
    },
    {
        "zone": "Asia/Tbilisi",
        "gmt": "(GMT+04:00)",
        "name": "Tbilisi"
    },
    {
        "zone": "Asia/Yerevan",
        "gmt": "(GMT+04:00)",
        "name": "Yerevan"
    },
    {
        "zone": "Asia/Kabul",
        "gmt": "(GMT+04:30)",
        "name": "Kabul"
    },
    {
        "zone": "Asia/Karachi",
        "gmt": "(GMT+05:00)",
        "name": "Karachi"
    },
    {
        "zone": "Asia/Tashkent",
        "gmt": "(GMT+05:00)",
        "name": "Tashkent"
    },
    {
        "zone": "Asia/Kolkata",
        "gmt": "(GMT+05:30)",
        "name": "Kolkata"
    },
    {
        "zone": "Asia/Kathmandu",
        "gmt": "(GMT+05:45)",
        "name": "Kathmandu"
    },
    {
        "zone": "Asia/Yekaterinburg",
        "gmt": "(GMT+06:00)",
        "name": "Yekaterinburg"
    },
    {
        "zone": "Asia/Almaty",
        "gmt": "(GMT+06:00)",
        "name": "Almaty"
    },
    {
        "zone": "Asia/Dhaka",
        "gmt": "(GMT+06:00)",
        "name": "Dhaka"
    },
    {
        "zone": "Asia/Novosibirsk",
        "gmt": "(GMT+07:00)",
        "name": "Novosibirsk"
    },
    {
        "zone": "Asia/Bangkok",
        "gmt": "(GMT+07:00)",
        "name": "Bangkok"
    },
    {
        "zone": "Asia/Jakarta",
        "gmt": "(GMT+07:00)",
        "name": "Jakarta"
    },
    {
        "zone": "Asia/Krasnoyarsk",
        "gmt": "(GMT+08:00)",
        "name": "Krasnoyarsk"
    },
    {
        "zone": "Asia/Chongqing",
        "gmt": "(GMT+08:00)",
        "name": "Chongqing"
    },
    {
        "zone": "Asia/Hong_Kong",
        "gmt": "(GMT+08:00)",
        "name": "Hong Kong"
    },
    {
        "zone": "Asia/Kuala_Lumpur",
        "gmt": "(GMT+08:00)",
        "name": "Kuala Lumpur"
    },
    {
        "zone": "Australia/Perth",
        "gmt": "(GMT+08:00)",
        "name": "Perth"
    },
    {
        "zone": "Asia/Singapore",
        "gmt": "(GMT+08:00)",
        "name": "Singapore"
    },
    {
        "zone": "Asia/Taipei",
        "gmt": "(GMT+08:00)",
        "name": "Taipei"
    },
    {
        "zone": "Asia/Ulaanbaatar",
        "gmt": "(GMT+08:00)",
        "name": "Ulaan Bataar"
    },
    {
        "zone": "Asia/Urumqi",
        "gmt": "(GMT+08:00)",
        "name": "Urumqi"
    },
    {
        "zone": "Asia/Irkutsk",
        "gmt": "(GMT+09:00)",
        "name": "Irkutsk"
    },
    {
        "zone": "Asia/Seoul",
        "gmt": "(GMT+09:00)",
        "name": "Seoul"
    },
    {
        "zone": "Asia/Tokyo",
        "gmt": "(GMT+09:00)",
        "name": "Tokyo"
    },
    {
        "zone": "Australia/Adelaide",
        "gmt": "(GMT+09:30)",
        "name": "Adelaide"
    },
    {
        "zone": "Australia/Darwin",
        "gmt": "(GMT+09:30)",
        "name": "Darwin"
    },
    {
        "zone": "Asia/Yakutsk",
        "gmt": "(GMT+10:00)",
        "name": "Yakutsk"
    },
    {
        "zone": "Australia/Brisbane",
        "gmt": "(GMT+10:00)",
        "name": "Brisbane"
    },
    {
        "zone": "Australia/Canberra",
        "gmt": "(GMT+10:00)",
        "name": "Canberra"
    },
    {
        "zone": "Pacific/Guam",
        "gmt": "(GMT+10:00)",
        "name": "Guam"
    },
    {
        "zone": "Australia/Hobart",
        "gmt": "(GMT+10:00)",
        "name": "Hobart"
    },
    {
        "zone": "Australia/Melbourne",
        "gmt": "(GMT+10:00)",
        "name": "Melbourne"
    },
    {
        "zone": "Pacific/Port_Moresby",
        "gmt": "(GMT+10:00)",
        "name": "Port Moresby"
    },
    {
        "zone": "Australia/Sydney",
        "gmt": "(GMT+10:00)",
        "name": "Sydney"
    },
    {
        "zone": "Asia/Vladivostok",
        "gmt": "(GMT+11:00)",
        "name": "Vladivostok"
    },
    {
        "zone": "Asia/Magadan",
        "gmt": "(GMT+12:00)",
        "name": "Magadan"
    },
    {
        "zone": "Pacific/Auckland",
        "gmt": "(GMT+12:00)",
        "name": "Auckland"
    },
    {
        "zone": "Pacific/Fiji",
        "gmt": "(GMT+12:00)",
        "name": "Fiji"
    }
]